import { BaseParser, DATA_TYPE_DATA, TYPE_2D } from './baseExtractor';

// Keep regex patterns and icons local since they're only used in this file
const reTxtExt = /(.*)\.txt$/i;
const rePssExt = /(.*)\.pss$/i;
const iconTxt = 'txtFile.png';
const iconPss = 'pssFile.png';
const notifyZone = 'Comma Separated Files Extraction';

class commaSepExtractor extends BaseParser {
  separateLinesFile(data) {
    let dataSplit = data.replaceAll('\n', '').split('\r');
    if (dataSplit.length > 1) {
      return dataSplit;
    }
    dataSplit = data.replaceAll('\r', '').split('\n');
    if (dataSplit.length > 1) {
      return dataSplit;
    }
  
    dataSplit = data.replaceAll(String.fromCharCode(13), '').split(String.fromCharCode(10));
    if (dataSplit.length > 1) {
      return dataSplit;
    }
    dataSplit = data.replaceAll(String.fromCharCode(10), '').split(String.fromCharCode(13));
    if (dataSplit.length > 1) {
      return dataSplit;
    }
    return null;
  }
  
  separateDataFile(line) {
    const separatorTry = ['\t', ';', ' ', '  ', '   '];
    for (const separator of separatorTry) {
      const linesplitted = line.split(separator);
      if (
        linesplitted.length >= 2 &&
        !isNaN(parseFloat(linesplitted[0])) &&
        !isNaN(parseFloat(linesplitted[1]))
      ) {
        return linesplitted;
      }
    }
    //Check with comma or dot, it depends which gives lower value greater than 1
    const linesplittedComma = line.split(',');
    const linesplittedDot = line.split('.');
    if (
      (linesplittedComma.length === 2 ||
        (linesplittedComma.length > 1 &&
          linesplittedDot.length >= linesplittedComma.length)) &&
      !isNaN(parseFloat(linesplittedComma[0])) &&
      !isNaN(parseFloat(linesplittedComma[1]))
    ) {
      return linesplittedComma;
    }
    if (
      linesplittedDot.length >= 2 &&
      !isNaN(parseFloat(linesplittedDot[0])) &&
      !isNaN(parseFloat(linesplittedDot[1]))
    ) {
      return linesplittedDot;
    }
    return null;
  }

  // eslint-disable-next-line no-unused-vars
  async _doParse(parent, fileName, data, report) {
    throw new Error('_doParse must be implemented by subclass');
  }
}

class TXTExtractor extends commaSepExtractor {
  // eslint-disable-next-line no-unused-vars
  async _doParse(parent, fileName, data, report) {
    const returnValue = this.getNewReturnValue();
    const dataSplit = this.separateLinesFile(data);
    if (dataSplit === null) {
      returnValue.lastError = `Error the file "${fileName}" has a incorrect format, cannot separate the lines.`;
      return returnValue;
    }
    const X = []; // Vector of common x values
    const Yarr = []; // Array of arrays

    // Loop over rows
    for (let j = 0; j < dataSplit.length; j++) {
      const line = dataSplit[j];
      const linesplitted = this.separateDataFile(line);
      if (linesplitted === null) {
        continue;
      }

      const newX = parseFloat(linesplitted[0])
      X.push(newX); // The first column is shared across y

      const Ytemp = [];

      for (let k = 1; k < linesplitted.length; k++) {
        Ytemp.push(parseFloat(linesplitted[k]));
      }
      Yarr.push(Ytemp);
    }

    // If data is cyclic, find the vertices and chop into separate datalines
    const vertices = [];
    let consecutiveFoundVertice = false
    for (let i = 0; i < X.length; i++) {
      if (!consecutiveFoundVertice && X[i] === X[0]) {
          vertices.push(i)
          consecutiveFoundVertice = true
      }else
      consecutiveFoundVertice = false
    }
    vertices.push(X.length)
    let invalidCells = []
    // Loop over rows again
    for (let i = 0; i < Yarr[0].length; i++) {
      for (let k = 0; k < vertices.length - 1; k++) {
        const idx = [vertices[k], vertices[k+1]];
        const dataExtract = this.getDataFromFileName(fileName, reTxtExt); //Extract data from the file name
        dataExtract.scan = k + 1;
        const Y = [];
        let datalineX = X.slice(idx[0], idx[1])
        let counterDatalineX = 0
        for (let j = idx[0]; j < idx[1]; j++) {
          if(!isNaN(Yarr[j][i])){
            Y.push(Yarr[j][i]);
            counterDatalineX++;
          }else{
            // If the value isn't valid in Y. Then remove the element and mark it
            datalineX.splice(counterDatalineX, 1);
            invalidCells.push(`(${i}, ${j})`)
          }
        }
        if(Y.length === 0)
          continue;
        const newElement = {
          title: `${dataExtract.title} ${i+1},${k+1}`,
          group: dataExtract.group,
          concUnit: dataExtract.concUnit,
          X: datalineX,
          Y: Y,
          fileName: fileName,
        };
        if (typeof dataExtract.mapping !== 'undefined') {
          newElement.mapping = dataExtract.mapping;
        }
        if (typeof dataExtract.scan !== 'undefined') {
          newElement.scan = dataExtract.scan;
        }
        returnValue.processedData.push(newElement);
      }
    }
    if(invalidCells.length > 0){
      const warnText = invalidCells.length > 10 ? `${Yarr[0].length} columns found with ${invalidCells.length} invalid cells` : `Invalid cells found: ${invalidCells.join(', ')}`;
      const warnTitle = 'Invalid cells';
      parent.$notifTerm.addNotification(
        parent.$notifTerm.typesNotif.WARNING,
        warnTitle,
        warnText,
        notifyZone,
      );
    }
    returnValue.lastError = returnValue.processedData.length === 0 ? `File '${fileName}' is empty` : '';
    returnValue.dataType = DATA_TYPE_DATA;
    returnValue.type = TYPE_2D;
    returnValue.icon = iconTxt;
    returnValue.success = returnValue.processedData.length > 0;
    return returnValue;
  }
}

class PSSExtractor extends commaSepExtractor {
  // eslint-disable-next-line no-unused-vars
  async _doParse(parent, fileName, data, report) {
    const returnValue = this.getNewReturnValue();
    const dataSplit = this.separateLinesFile(data);
  
    if (dataSplit === null) {
      returnValue.lastError = `Error the file "${fileName}" has a incorrect format, cannot separate the lines.`;
      return returnValue;
    }
    const X = [];
    const Y = [];
    for (let j = 0; j < dataSplit.length; j++) {
      const line = dataSplit[j];
      const linesplitted = this.separateDataFile(line);

      if (linesplitted === null) {
        continue;
      }
      X.push(parseFloat(linesplitted[0]));
      Y.push(parseFloat(linesplitted[1]));
    }

    const dataExtract = this.getDataFromFileName(fileName, rePssExt); //Extract data from the file name
    const newElement = {
      title: dataExtract.title,
      group: dataExtract.group,
      concUnit: dataExtract.concUnit,
      X: X,
      Y: Y,
      fileName: fileName,
    };

    if (typeof dataExtract.mapping !== 'undefined') {
      newElement.mapping = dataExtract.mapping;
    }
    if (typeof dataExtract.scan !== 'undefined') {
      newElement.scan = dataExtract.scan;
    }
    returnValue.processedData = [newElement];
    returnValue.lastError = returnValue.processedData.length === 0 ? `File '${fileName}' is empty` : '';
    returnValue.dataType = DATA_TYPE_DATA;
    returnValue.type = TYPE_2D;
    returnValue.icon = iconPss;
    returnValue.success = returnValue.processedData.length > 0;
    return returnValue;
  }
}

export{
  TXTExtractor,
  PSSExtractor,
};
